import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useSupportingColors } from '../../hooks/use-supporting-colors';
import { Text } from '@hub/text';
import { Stack } from '@hub/stack';
import { Link } from '@hub/link';
import trackClickEvents, { categories, labels } from '../analytics/trackEvents';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ColorCardContent = _ref => {
  let {
    isFullWidth,
    title,
    shortDescription,
    callToAction,
    supplementaryText,
    supportingColor,
    position,
    index,
    tag,
    clickEvent
  } = _ref;
  const {
    supportingForegroundColor: primaryForegroundColor
  } = useSupportingColors(supportingColor);
  return /*#__PURE__*/_jsxs(Stack, {
    sx: _objectSpread(_objectSpread({}, isFullWidth && {
      width: '100%',
      marginX: 'auto'
    }), {}, {
      color: primaryForegroundColor,
      paddingBottom: 'spacing-md'
    }),
    gap: "spacing-md",
    "data-id": "color-cards_color-card-content_ColorCardContent_Stack",
    children: [/*#__PURE__*/_jsxs(Box, {
      "data-id": "color-cards_color-card-content_ColorCardContent_Stack_Box",
      children: [/*#__PURE__*/_jsx(Text, {
        noOfLines: 2,
        tone: "strong",
        "data-id": "color-cards_color-card-content_ColorCardContent_Box_Text",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        "data-id": "color-cards_color-card-content_ColorCardContent_Box_Text_3",
        children: shortDescription
      })]
    }), supplementaryText && /*#__PURE__*/_jsx(Text, {
      noOfLines: 3,
      "data-id": "color-cards_color-card-content_ColorCardContent_Text_4",
      children: supplementaryText
    }), callToAction && /*#__PURE__*/_jsx(Text, {
      sx: {
        color: primaryForegroundColor
      },
      "data-id": "color-cards_color-card-content_ColorCardContent_Text_5",
      children: /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: callToAction.url,
        onClick: () => {
          if (clickEvent) {
            clickEvent(index !== null && index !== void 0 ? index : 0);
          }
          trackClickEvents.clicked(categories.COLOUR_CARD, labels.createTitleAndPosition(title, position !== null && position !== void 0 ? position : 1));
        },
        as: "a",
        "data-id": "color-cards_color-card-content_ColorCardContent_Text_Link",
        children: callToAction.label
      })
    }), tag && /*#__PURE__*/_jsx(Text, {
      sx: {
        fontSize: 'font-sm'
      },
      "data-id": "color-cards_color-card-content_ColorCardContent_Text",
      children: tag
    })]
  });
};